export default {
  'Enter a promo code! First limit people receive amount coins':
    '输入促销代码！第一限制的人收到金额的硬币',
};
